import React, { useEffect, useState } from 'react'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { VariableVCards } from '../VariableVCards'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Warning from '../../../components/general/general-component/warning-delete/Warning'
import { ColumnVCards } from '../../../components/general/general-component/columns-component/ColumnVCards'
import Table2 from '../../../components/table/Table2'
import InnerLoader from '../../../components/general/inner-loader/InnerLoader'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'

const fake=[
    {
        id: 1,
        name: "test 1",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSqO-QObzsHdD8Sdkdztghx0oG4l84j1o4_g&s",
        url: "https://translate.google.com/",
        status: true,
        created_at: "02-03-2024",
    },
    {
        id: 2,
        name: "test 2",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSqO-QObzsHdD8Sdkdztghx0oG4l84j1o4_g&s",
        url: "https://translate.google.com/",
        status: false,
        created_at: "03-03-2024",
    },{
        id: 3,
        name: "test 3",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSqO-QObzsHdD8Sdkdztghx0oG4l84j1o4_g&s",
        url: "https://translate.google.com/",
        status: true,
        created_at: "04-03-2024",
    }
]

const TableCard = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { vcards, loadingVcards } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableVCards()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [vcardsArr, setVcardsArr] = useState(fake)
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)

    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...vcardsArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setVcardsArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, vcardsArr]);
    /*useEffect(() => {
        if (vcards?.length >= 0) {
            setVcardsArr(vcards)
        }
    }, [vcards]);*/
    useEffect(() => {
       // dispatch(loadUsers())
    }, []);
    const handleDelete = (id) => {
        //dispatch(deleteUser(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openAddUser = e => {
        e.preventDefault()
        setOpen(true)
    }
    const { columns } = ColumnVCards(translate, warning, handleEdit, langLocal)
    return (
        <CheckLazyLoader route='/dashboard/users' >
            <main>
                <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <SectionTopOfTable isSearch langLocal={langLocal} title={translate('vcard')} titleBtn={translate('add_vcard')} FunctionBtn={openAddUser} />
                    {/*
                        loadingVcards == false ? (
                            <Table2 col={columns} roo={vcardsArr} />
                        ) : <InnerLoader />
                    */}
                    <Table2 col={columns} roo={vcardsArr} />
                </div>
            </main>
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
        </CheckLazyLoader>
    )
}

export default TableCard
